import TrainerLayout from "../layouts/trainer-layout";
import AnnuelCalendarFormateur from "../pages/Formateur/agenda/annuels/AnnuelCalendarFormateur";
import LayoutCalendarFormateur from "../layouts/formateurs/LayoutCalendarFormateur";
import SemaineCalendarFormateur from "../pages/Formateur/agenda/semaines/SemaineCalendarFormateur";
import ProjectFormList from "../pages/Formateur/evaluation/ProjectFormList";
import ProjectFormDetails from "../pages/Formateur/evaluation/ProjectFormDetails";
import { SupportContent } from "../contents/support-content";
import LeanerListFormateur from "../pages/Formateur/learner";
import { TestingContent } from "../contents/testing-content";
import { PhotoContent } from "../contents/photoContent";
import { HomeContentAttendance } from "../contents/home-content";
import { AuthCalendarProvider } from "../contexts/AuthCalendarProvider";
import { Attendance } from "../pages/Cfp/attendance";
import Accueil from "../pages/Apprenants/Support/Accueil";
import CentreList from "../pages/Apprenants/Support/Centre/CentreList";
import ProgramList from "../pages/Apprenants/Support/Programme/ProgramList";
import CentreDetail from "../pages/Apprenants/Support/Centre/CentreDetail";
import ProgramDetail from "../pages/Apprenants/Support/Programme/ProgramDetail";
import { FolderAppr } from "../pages/Apprenants/Photo/folder-appr";
import { ProjectAppr } from "../pages/Apprenants/Photo/project-appr";
import { CrudImageAppr } from "../pages/Apprenants/Photo/crud-image-appr";
// import QcmIndex from "../pages/Apprenants/Testing/QcmIndex";
// import DetailsQcm from "../pages/Apprenants/Testing/Qcms/DetailsQcm";
// import ResultQcm from "../pages/Apprenants/Testing/ResultQcm";
// import TestReviewResponse from "../pages/Apprenants/Testing/TestReviewResponse";
// import TestResults from "../pages/Apprenants/Testing/TestResults";
// import InvitationList from "../pages/Apprenants/Testing/InvitationList";
// import InvitationDetails from "../pages/Apprenants/Testing/InvitationDetails";
import GamificationPage from "../pages/Apprenants/Gamification/gamification-page";
import PageProjets from "../pages/Apprenants/Projet/projet";
import Refresh from "../pages/Apprenants/Refresh/Refresh";
import LayoutCalendarApprenant from "../layouts/apprenants/LayoutCalendarApprenant";
import SemaineCalendarApprenant from "../pages/Apprenants/agenda/semaines/SemaineCalendarApprenant";
import AnnuelCalendarApprenant from "../pages/Apprenants/agenda/annuels/AnnuelCalendarApprenant";
import QCMComponent from "../pages/Apprenants/Testing/Qcms/QCMComponent";
import HomePageForm from "../pages/Formateur/home";
import ProjectTrainer from "../pages/Formateur/projet/index";
import ProjectTrainerDetail from "../pages/Formateur/projet/detail";
import { SearchProviderProject } from "../contexts/cfp/SearchContextProject";
import { PhotoContentFormateur } from "../contents/photo-content-formateur";
import { FolderFormateurs } from "../pages/Formateur/photo/folder-formateur.";
import { ProjectFormateur } from "../pages/Formateur/photo/project-formateur";
import { CrudImageFormateur } from "../pages/Formateur/photo/crud-image-formateur";
import SkillTrainerContent from "../contents/skillTrainer-content";
import FormateurProjectList from "../pages/Formateur/skill_matrix/FormateurProjectList";
import FormateurSkills from "../pages/Formateur/skill_matrix/FormateurSkills";
import EvaluationsFroids from "../pages/Cfp/evaluationFroid";
import QcmIndexFormateur from "../pages/Formateur/Testing/QcmIndexFormateur";
import DetailsQcmFormateur from "../pages/Formateur/Testing/show-details-formateur";
import ResultQcmFormateur from "../pages/Formateur/Testing/result-qcm-formateur";
import RapportFormateur from "../pages/Formateur/Testing/rapport-formateur";
import BaremeFormateur from "../pages/Formateur/Testing/bareme-formateur";
import EvaluationFormateur from "../pages/Formateur/Testing/evaluation-formateur";
import CreateQcmFormateur from "../pages/Formateur/Testing/qcm-create-formateur";
import CampaignListFormateur from "../pages/Formateur/Testing/Campaign/campaign-list-formateur";
import InvitationListFormateur from "../pages/Formateur/Testing/invitations/invitation-list-formateur";
import InvitationDetailsFormateur from "../pages/Formateur/Testing/invitations/invitations-details-formateur";
import CampaignStepOneFormateur from "../pages/Formateur/Testing/Campaign/create-step-one";
import CampaignStepTwoFormateur from "../pages/Formateur/Testing/Campaign/create-step-two-formateur";
import CampaignStepThreeFormateur from "../pages/Formateur/Testing/Campaign/create-step-three";
import CampaignStepFourFormateur from "../pages/Formateur/Testing/Campaign/create-step-four";
import GlobalResultsFormateur from "../pages/Formateur/Testing/global-results-formateur";
import DetailsResultsFormateur from "../pages/Formateur/Testing/details-results-formateur";
import EditQcmFormateur from "../pages/Formateur/Testing/qcm-edit-formateur";
import CreateInvitationFormateur from "../pages/Formateur/Testing/Campaign/create-invitation-Formateur";
import { TestingContentForm } from "../contents/TestingContentForm";
import Profile from "../pages/Formateur/Profile";
import { Navigate } from "react-router-dom";
import ManageSkillTrainer from "../pages/Formateur/skill_matrix/ManageSkillTrainer";
import LayoutSkillTrainer from "../layouts/layout-skill-trainer";
import { ProjectFinished } from "../pages/Formateur/projet/finished";
import { ProjectInProgress } from "../pages/Formateur/projet/in-progress";
import { ProjectInPreparation } from "../pages/Formateur/projet/in-preparation";
import { ProjectCanceled } from "../pages/Formateur/projet/canceled";
import { ProjectFenced } from "../pages/Formateur/projet/fenced";
import { ProjectDeferred } from "../pages/Formateur/projet/deferred";
import { ProjectPlanned } from "../pages/Formateur/projet/planned";
import { TrainerAttendanceContent } from "../contents/TrainerAttendanceContent";
import { ModuleProvider } from "../contexts/ModuleContext";
import RefreshLayoutFormateur from "../layouts/formateurs/refresh-layout-formateur";
import Module from "../pages/Formateur/refresh/Module";
import Liste from "../pages/Formateur/refresh/Liste";
import Create from "../pages/Formateur/refresh/Create";
import PresenceFormateur, {
  AttendanceTrainer,
} from "../pages/Formateur/attendance";
import EmargementTrainer from "../pages/Formateur/attendance/emargementTrainer";
import LearnerLayoutFormateur from "../layouts/formateurs/learner-layout-formateur";

const trainerRoutes = {
  path: "/formateur",
  element: <TrainerLayout />,
  children: [
    {
      index: true,
      element: <HomePageForm />,
    },
    {
      path: "photos",
      element: <PhotoContent />,
      children: [
        {
          index: true,
          element: <FolderFormateurs />,
        },
        {
          path: "projets",
          element: <ProjectFormateur />,
        },
        {
          path: "ajout/:idProjet",
          element: <CrudImageFormateur />,
        },
      ],

    },
    {
      path: "agenda",
      element: <AuthCalendarProvider />,
      children: [
        {
          element: <LayoutCalendarFormateur />,
          children: [
            {
              index: true,
              element: <AnnuelCalendarFormateur />,
            },
            {
              path: "annuel",
              element: <AnnuelCalendarFormateur />,
            },
            {
              path: "semaine",
              element: <SemaineCalendarFormateur />,
            },
          ],
        },
        {
          // path: "presence",
          element: <HomeContentAttendance />,
          children: [
            {
              index: true,
              element: <Attendance />,
            },
          ],
        },
        {
          path: "support",
          element: <SupportContent />,
          children: [
            {
              index: true,
              element: <Accueil />,
            },
            {
              path: "centre",
              element: <CentreList />,
            },
            {
              path: "centre/:id",
              element: <CentreDetail />,
            },
            {
              path: "programmes",
              element: <ProgramList />,
            },
            {
              path: "programmes/:id",
              element: <ProgramDetail />,
            },
          ],
        },
        // {
        //   path: "photo",
        //   element: <PhotoContent />,
        //   children: [
        //     {
        //       index: true,
        //       element: <FolderFormateurs />,
        //     },
        //     {
        //       path: "projets",
        //       element: <ProjectFormateur />,
        //     },
        //     {
        //       path: "ajout/:idProjet",
        //       element: <CrudImageFormateur />,
        //     },
        //   ],
        // },

        {
          path: "gamification",
          element: <GamificationPage />,
        },
        //projet
        {
          path: "projet",
          element: <PageProjets />,
        },
        {
          path: "refreshd",
          element: <Refresh />,
        },
        {
          path: "agenda",
          element: <AuthCalendarProvider />,
          children: [
            {
              element: <LayoutCalendarApprenant />,
              children: [
                {
                  index: true,
                  element: <AnnuelCalendarApprenant />,
                },
                {
                  path: "annuel",
                  element: <AnnuelCalendarApprenant />,
                },
                {
                  path: "semaine",
                  element: <SemaineCalendarApprenant />,
                },
              ],
            },
          ],
        },
      ],
    },


    {
      path: "/formateur/refresh",
      element: (
        <ModuleProvider>
          {" "}
          <RefreshLayoutFormateur />{" "}
        </ModuleProvider>
      ),
      children: [
        {
          index: true,
          // element: <Navigate to="module" />,
          element: <Module />,
        },
        {
          path: "liste",
          // element: <Module />,
          element: <Liste />,
        },
        {
          path: "creer",
          element: <Create />,
        },
      ],
    },

    {
      path: "presence",
      element: <TrainerAttendanceContent />,
      children: [
        {
          index: true,
          element: <AttendanceTrainer />,
        },
        {
          path: "emargement/:id",
          element: <EmargementTrainer />,
        },
      ],
    },
    {
      path: "evaluations",
      element: <ProjectFormList />,
    },
    {
      path: "evaluations-froid",
      element: <EvaluationsFroids apiUrl="formateur/eval-froid" />,
    },
    {
      path: "evaluations/projetsForm/:idProjet/detailForm",
      element: <ProjectFormDetails />,
    },
    // {
    //   path: "apprenant",
    //   element: <LeanerListFormateur />,
    // },
    {
      path: "apprenant",
      element: <LearnerLayoutFormateur />,
      children: [
        {
          index: true,
          element: <LeanerListFormateur />,
        },
      ],
    },
    {
      path: "projects",
      element: <SearchProviderProject />,
      children: [
        {
          index: true,
          element: <ProjectTrainer />,
        },
        {
          path: "detail/:id",
          element: <ProjectTrainerDetail />,
        },
        { path: "termine", element: <ProjectFinished /> },
        { path: "en_cours", element: <ProjectInProgress /> },
        { path: "preparation", element: <ProjectInPreparation /> },
        { path: "planifie", element: <ProjectPlanned /> },
        { path: "annule", element: <ProjectCanceled /> },
        { path: "cloture", element: <ProjectFenced /> },
        { path: "reporte", element: <ProjectDeferred /> },
      ],
    },
    {
      path: "skill_matrix",
      element: <LayoutSkillTrainer />,
      children: [
        {
          index: true,
          element: <Navigate to="projets" />,
        },
        {
          path: "projets",
          element: <FormateurProjectList />,
        },
        {
          path: "projets/:idProjet",
          element: <FormateurSkills />,
        },
        {
          path: "gestion-skill",
          element: <ManageSkillTrainer />,
        },
      ],
    },
    {
      path: "testing",
      element: <TestingContentForm />,
      children: [
        {
          index: true,
          element: <QcmIndexFormateur />,
        },
        {
          path: "qcm/:id/edit",
          element: <EditQcmFormateur />,
        },
        {
          path: "qcm/show/:id",
          element: <DetailsQcmFormateur />,
        },
        {
          path: "qcm/:id/list-apprenants/results",
          element: <ResultQcmFormateur />,
        },
        {
          path: "qcm/:id/apprenant/:idApprenant/session/:idSession/rapport",
          element: <RapportFormateur />,
        },
        {
          path: "qcm/bareme/create/:id",
          element: <BaremeFormateur />,
        },
        {
          path: "qcm/:id/category-evaluations",
          element: <EvaluationFormateur />,
        },
        {
          path: "qcm/create",
          element: <CreateQcmFormateur />,
        },
        {
          path: "qcm/invitation/campaign",
          element: <CampaignListFormateur />,
        },
        {
          path: "qcm/invitation/create",
          element: <CreateInvitationFormateur />,
        },
        {
          path: "qcm/invitations-index",
          element: <InvitationListFormateur />,
        },
        {
          path: "qcm/invitations/:id",
          element: <InvitationDetailsFormateur />,
        },
        {
          path: "qcm/campaign/create-1",
          element: <CampaignStepOneFormateur />,
        },
        {
          path: "qcm/campaign/create-2",
          element: <CampaignStepTwoFormateur />,
        },
        {
          path: "qcm/campaign/create-3",
          element: <CampaignStepThreeFormateur />,
        },
        {
          path: "qcm/campaign/create-4",
          element: <CampaignStepFourFormateur />,
        },
        {
          path: "global-results",
          element: <GlobalResultsFormateur />,
        },
        {
          path: "qcm/:id/appr/:idAppr/session/:idSession/result",
          element: <DetailsResultsFormateur />,
        },
      ],
    },
    {
      path: "profile",
      element: <Profile />,
    },
  ],
};

export default trainerRoutes;
